import axios from '../axiosConfig';
import React, { useEffect, useState } from 'react';
import TimePicker from 'react-times';
// use material theme
import 'react-times/css/material/default.css';
import { arreglarReloj, handleError, toastError, toastSuccess, toastWarningUnique } from '../funciones';

// or you can use classic theme
//import 'react-times/css/classic/default.css';

function ModalExisteCuit(props) {

    const [representantes, setRepresentantes] = useState([]);
    const [horaSalida, setHoraSalida] = useState(-1);
    const [horaEntrada, setHoraEntrada] = useState(-1);
    const [horaSalidaMax, setHoraSalidaMax] = useState("20:00");
    const [horaEntradaMin, setHoraEntradaMin] = useState("08:00");

    useEffect(() => {


        const params = {
            params: {
                empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }
        axios
            .get(process.env.REACT_APP_URL + 'empresa/verRepresentantesDeUnaEmpresa', params)
            .then(function (response) {
                setRepresentantes(response.data);
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
    }, [])

    useEffect(() => {
        if (props.inscripcionModificar !== null && props.inscripcionModificar !== undefined) {
            setHoraEntrada(props.inscripcionModificar.inscripcionHoraInicio);
            setHoraSalida(props.inscripcionModificar.inscripcionHoraFin);
            setHoraEntradaMin(props.inscripcionModificar.eventoHoraInicio);
            setHoraSalidaMax(props.inscripcionModificar.eventoHoraFin);
            document.getElementById("selectRepresentante").value = props.inscripcionModificar.representanteId ?? "";
            arreglarReloj();
        }

    }, [props.inscripcionModificar])

    useEffect(() => {

        if (props.horaInicioEvento !== -1 && props.horaInicioEvento != null && props.horaInicioEvento != undefined) {
            setHoraEntrada(props.horaInicioEvento);
            setHoraSalida(props.horaFinEvento);
            setHoraEntradaMin(props.horaInicioEvento);
            setHoraSalidaMax(props.horaFinEvento);
            arreglarReloj();
        }
    }, [props.horaInicioEvento])

    function inscribirse() {
        const elem = document.getElementById("selectRepresentante");
        var idEvento = localStorage.getItem(process.env.REACT_APP_ID_EVENTO);

        if (horaEntrada === -1) {
            toastError("Debe seleccionar la hora de entrada")
        }
        else if (horaSalida === -1) {
            toastError("Debe seleccionar la hora de salida")
        }
        else if (elem.value === '') {
            toastError("Debe seleccionar un representante")
        }
        else {
            var params, url;
            if (props.esModificar) {
                url = 'inscripcion/modificarRepresentanteYHorario';
                params = {
                    horaInicio: horaEntrada,
                    horaFin: horaSalida,
                    representante:
                    {
                        id: elem.value
                    },
                    id: localStorage.getItem(process.env.REACT_APP_ID_INSCRIPCION)
                }
                axios
                    .put(process.env.REACT_APP_URL + url, params)
                    .then((res) => {
                        props.modificarInscripcion(params);
                        document.getElementById("btnClose").click();
                        toastSuccess("Inscripción modificada")
                    })
                    .catch(function (error) {
                        toastError(handleError(error))
                    })
            }
            else {
                url = 'inscripcion';

                params = {
                    horaInicio: horaEntrada,
                    horaFin: horaSalida,
                    representante:
                    {
                        id: elem.value
                    },
                    empresaInscripta: {
                        id: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
                    },
                    evento: {
                        id: idEvento
                    }
                }
                axios
                    .post(process.env.REACT_APP_URL + url, params)
                    .then((res) => {
                        //if(!props.esModificar)
                        props.agregarModificado(idEvento);
                        toastSuccess("Inscripción realizada")

                        document.getElementById("btnClose").click();
                    })
                    .catch(function (error) {
                        toastError(handleError(error))
                    })
            }


        }



    } 
    return (
        <>

            <div class="modal fade " id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 modal-inscripciones">

                        <div class="modal-body p-0">
                            <button type="button" id='btnClose' class="btn-close btn-close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className='container px-5 py-4'>
                                <div className='row'>
                                    <div className='col'>
                                        <h2 className='text-color-principal titulos text-center'>Ronda de Negocios</h2>
                                    </div>
                                </div>
                                <div className={'row horarios' + (props.permitirElegirHorario? "": " d-none")}>
                                    <p className='fw-bold m-bot-modal'>Seleccione sus horarios:</p>
                                    <div className='col colHorariosMobile'>
                                        <div className='colorGrisLetra bold-botones text-center'>Horario de entrada</div>
                                        <div id='horaEntrada'>  </div>
                                    </div>
                                    <div className='col colHorariosMobile'>
                                        <div className='colorGrisLetra bold-botones text-center'>Horario de salida</div>
                                         
                                    </div>
                                </div>

                                <div className={'row' + (props.permitirElegirHorario? "": " my-2")}>
                                    <div className='col'>
                                        <p className='fw-bold m-bot-modal'>Seleccione su representante:</p>

                                        {representantes.length !== 0 ?
                                            <select id='selectRepresentante' class="form-select colorGrisLetra bold-botones bordesForms select-normal" aria-label="Default select example">
                                                {
                                                    representantes.map(function (elem) {
                                                        return (
                                                            <>
                                                                <option value={elem.id}>{elem.apellido + ", " + elem.nombre}</option>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </select>
                                            :
                                            <select id='selectRepresentante' class="form-select bold-botones bordesForms" aria-label="Disabled select example" disabled>
                                                <option selected value="">No posee representantes</option>
                                            </select>
                                        }
                                    </div>
                                </div>
                                {/*   <div className='text-center'>
                                    <button class="btn btn-outline-primary bold-botones mt-b1" type="submit">Agregar Representante</button>
                                </div>*/}
                                <div className='text-center py-2'>
                                    <button class="btn colorPrincipal text-white bold-botones mt-4 btn-cuadrado" type="submit" onClick={inscribirse}>
                                        {props.esModificar ?
                                            "Modificar"
                                            :
                                            "Inscribirse"
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}


export default ModalExisteCuit;